import { useSelector } from 'react-redux';

export default function Pagination({ paginate }) {
  const { videos, isLoading, isError, error, currentPage, videosPerPage } =
    useSelector((state) => state.videos);
  const totalVideos = videos.length;

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalVideos / videosPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <section className="pt-12">
      <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
        {pageNumbers.map((number) => (
          <div
            onClick={() => paginate(number)}
            className="bg-blue-300 text-white px-4 py-1 rounded-full"
            key={number}
          >
            <button>{number}</button>
          </div>
        ))}
        {/* <div className="bg-blue-600 text-white px-4 py-1 rounded-full">
                    1
                </div> */}
        {/* <div className="bg-blue-100 text-blue-600 px-4 py-1 rounded-full">
                    2
                </div>
                <div className="bg-blue-100 text-blue-600 px-4 py-1 rounded-full">
                    3
                </div>
                <div className="bg-blue-100 text-blue-600 px-4 py-1 rounded-full">
                    4
                </div> */}
      </div>
    </section>
  );
}
